import {Component} from '@angular/core';
import {
	EntitySelectComponent,
	BaseModel,
	BaseModelInterface,
} from '@app/abstracts';
import {ErrorService} from '@app/services';
import {AudioDescriptionSearchParams} from '../audio-description-search-params';
import {AudioDescriptionService} from '../audio-description.service';
import {AudioDescription} from '../audio-description';
import { QuickFormService } from '../../../plugins/quick-form';
@Component({
  selector: 'hpf-audio-description-select',
  templateUrl: '../../../abstracts/entity-select/entity-select.component.html'
})
export class AudioDescriptionSelectComponent extends EntitySelectComponent< AudioDescription> {
  protected modelName = 'audio_description';
  /**
   * Constructor
   * @param {AudioDescriptionService} audioDescriptionService
   * @param {ErrorService} errorService
   */
  constructor(private audioDescriptionService: AudioDescriptionService,
              protected errorService: ErrorService,
              protected quickFormService: QuickFormService) {
    super(errorService, quickFormService);
  }
  ngOnInit() {
		super.ngOnInit();
    // Refresh model in case of creation by quick form
		this.subscriptions.push(
			this.quickFormService.refresh.subscribe(
				(model: BaseModel<BaseModelInterface, {}>) => {
					if(!(model instanceof AudioDescription)) return;
          if(this.multiple) {
            if (!this.model) this.model = [];
            (<AudioDescription[]>this.model).push(<AudioDescription>model);
          } else {
            this.model = <AudioDescription>model;
          }
          this.refresh();
				}
			)
		);
	}
  /** @inheritDoc */
  protected async getList(): Promise< AudioDescription[]> {
      const params = new AudioDescriptionSearchParams({
          _limit: this.resultsLimit,
          _page: this.currentPage
      });
      if (this.filterEnabled && this.filterValue) {
        params.props._text = this.filterValue;
      }
      return (await this.audioDescriptionService.list(params.toObject())).items;
  }
  /** @inheritDoc */
  protected async getOne(id: string): Promise< AudioDescription> {
      return await this.audioDescriptionService.get(id);
  }
}
